import { EventCardHandler } from '@app/components/event-card-handler';
import { ScrollableButtons } from '@app/components/scrollable-buttons';

const categoryScrollId = 'event-buttons';

document.addEventListener('DOMContentLoaded', () => {
    (<any>window).cardHandlers = [];
    (<any>window).scrollableButtons = new ScrollableButtons(categoryScrollId);
});

/**
 * Runs after HTMX has loaded new content onto the page.
 */
document.addEventListener('htmx:afterSettle', () => {
    (<any>window).cardHandlers.forEach((handler: EventCardHandler) => handler.remove());

    (<any>window).cardHandlers = [];
    document.querySelectorAll('.event-card-expandable').forEach((element) => {
        (<any>window).cardHandlers.push(new EventCardHandler(element as HTMLElement));
    });

    // the previous buttons were removed by HTMX, the event handlers have to be removed and then new ones created for
    // the new buttons
    (<any>window).scrollableButtons.destroy();
    (<any>window).scrollableButtons = new ScrollableButtons(categoryScrollId);
});
